import { ReactNode } from 'react';
import { createGlobalStyle, css, ThemeProvider } from 'styled-components';

import {
  useFavIcon,
  useGetColorsTheme,
  useGetFontFamiliesTheme,
  useGetFontsTheme,
} from 'coreOld/hooks';
import { theme } from 'coreOld/themes';
import { getFontSource } from 'coreOld/utils';

interface IProps {
  children?: ReactNode;
}

interface GlobalStyleProps {
  fontFamilies?: any[];
  getFontDefinition?: (font: any) => any;
}

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  ${({ fontFamilies, getFontDefinition }) =>
    fontFamilies && getFontDefinition && fontFamilies.map((font) => getFontDefinition(font))}

  .slide-pane__overlay { 
    z-index: 10;
  }
`;

const getFontDefinition = (font) => {
  let additionalStyles = '';

  if (font?.['font-weight']) {
    additionalStyles += `font-weight: ${font['font-weight']};`;
  }

  if (font?.['font-style']) {
    additionalStyles += `font-style: ${font['font-style']};`;
  }

  return css`
    @font-face {
      font-family: ${font['font-family']};
      src: ${getFontSource(font['src'])};
      ${additionalStyles}
    }
  `;
};

/** @deprecated - to be remove when new design is implemented through all pages */
const Theme = ({ children }: IProps) => {
  const { colorsTheme } = useGetColorsTheme();
  const { fontsTheme } = useGetFontsTheme();
  const { fontFamiliesTheme } = useGetFontFamiliesTheme();

  useFavIcon();

  const mainTheme = {
    ...theme,
    colors: { ...colorsTheme },
    fonts: { ...fontsTheme },
  };

  return (
    <ThemeProvider theme={mainTheme}>
      <GlobalStyle fontFamilies={fontFamiliesTheme} getFontDefinition={getFontDefinition} />
      {children}
    </ThemeProvider>
  );
};

export default Theme;
